// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './stroe'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "quill/dist/quill.core.css"
import { Pagination } from 'element-ui';
import axios from 'axios'
import constant from './baseUrl.js'
Vue.use(constant);
Vue.use(ElementUI);
import { checkPermi, checkRole } from "@/utils/permission";
Vue.prototype.checkPermi = checkPermi
Vue.prototype.checkRole = checkRole
Vue.use(Pagination);

import commonApi from './commonApi'
Vue.prototype.commonApi = commonApi;

//部署上线设为========================
Vue.prototype.$globalPath = 'prod-api';
//开发环境设为 ''=======================
// Vue.prototype.$globalPath = '';

Vue.prototype.parseTime = (time, pattern) => {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 引入公共组件
import Bread from "@/components/Bread.vue";
import Search from "@/components/Search.vue";
import ManageSearch from "@/components/ManageSearch.vue";
import Sort from "@/components/Sort.vue";
import pagination from "@/components/Pagination.vue";
import videoItem from "@/components/videoItem.vue";
import Assess from "@/components/Assess.vue";
import LeftMenu from "@/nav/study/components/leftMenu.vue";
import cropper from '@/components/cropper/index.vue'
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"

// 富文本组件
import Editor from "@/components/Editor"
import History from "@/components/history"
// 文件上传组件
import FileUpload from "@/components/FileUpload"
import AllFileUpload from "@/components/AllFileUpload"
Vue.component("Bread", Bread);
Vue.component("Search", Search);
Vue.component("ManageSearch", ManageSearch);
Vue.component("Sort", Sort);
Vue.component("pagination", pagination);
Vue.component("videoItem", videoItem);
Vue.component("Assess", Assess);
Vue.component("LeftMenu", LeftMenu);
Vue.component('FileUpload', FileUpload)
Vue.component('AllFileUpload', AllFileUpload)
Vue.component('Editor', Editor)
Vue.component('History', History)
Vue.component('cropper', cropper)
Vue.component('ImageUpload', ImageUpload)

Vue.prototype.axios = axios;
// axios.defaults.baseURL = '/'
// axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js